/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringTaxPlanDto } from '../../models/backend-monitoring-tax-plan-dto';

export interface MonitoringScenariosTaxesRetrieve$Params {
  scenario_id: number;
}

export function monitoringScenariosTaxesRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosTaxesRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMonitoringTaxPlanDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosTaxesRetrieve.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMonitoringTaxPlanDto>;
    }),
  );
}

monitoringScenariosTaxesRetrieve.PATH = '/api/monitoring/scenarios/{scenario_id}/taxes/';
